/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
let isAjaxify = false;

  isAjaxify = true;


var free_mint_headband = 0;


var free_overnight_peel = 0;

  free_overnight_peel = 31703982702627;


/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return $.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  $.ajax(params);
};

ShopifyAPI.addDonation = function(variant) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: '&id=39340636733475&quantity=1',
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
//       $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      ajaxCart.load();
//       location.reload();
//       jQuery(".site-header__cart-toggle").trigger('click');
    }
  };
  $.ajax(params);
};


ShopifyAPI.removeDonation = function(variant) {
  var $body = $(document.body),
  line = jQuery('.ajaxcart__qty-num[data-id="39340636733475"]').data('line'),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: '&line='+line+'&quantity=0',
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
//       $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      ajaxCart.load();
    }
  };
  $.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  if (window.theme && window.theme.bazaarvoiceEvents) {
    let eventData = {
      type: 'AddToCart',
      value: $(form).serialize(),
      label: 'Adds a product to a cart.'
    }
    theme.bazaarvoiceEvents.emitConversionEvent(eventData)
  }

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: $(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  $.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  $.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// Clear cart
ShopifyAPI.clearCart = function(callback) {
  $.getJSON('/cart/clear.json', function() {
    if ((typeof callback) === 'function') {
      callback()
    }
    else {
      location.reload();
    }
  })
}

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItemById = function(id, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + id,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [id, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [id, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  $.ajax(params);
};


// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  $.ajax(params);
};

ShopifyAPI.addAllItems = function (array, bundling, collection) {
  Shopify.queue = [];
  
  var newArray = array.split(',');
  for (var i = 0; i < newArray.length; i++) {
    var product = newArray[i]
    Shopify.queue.push({
      variantId: product,
    });
  }

  Shopify.moveAlong = function() {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      var data = 'id='+ request.variantId + '&quantity=1'
      if (bundling) {
        data += "&properties%5Bbundling%5D=true"
        if (collection && collection != "") {
          data += '&properties%5Bcollection%5D='+collection
        }
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(res){
          Shopify.moveAlong();
        },
        error: function(){
          // if it's not last one Move Along else update the cart number with the current quantity
          if (Shopify.queue.length){
            Shopify.moveAlong()
          } else {
           console.log('nothing left');
          }
        }
      });
    }
    // If the queue is empty, we add 1 to cart
    else {
      if (isAjaxify) {
        ShopifyAPI.addToCartOk();
      }
      else {
        window.location = '/cart';
      }
    }
  };
  Shopify.moveAlong();
}

var ajaxQueue = $({});
$.ajaxQueue = function( ajaxOpts ) {
  var jqXHR,
    dfd = $.Deferred(),
    promise = dfd.promise();

  // run the actual query
  function doRequest( next ) {
    jqXHR = $.ajax( ajaxOpts );
    jqXHR.done( dfd.resolve )
      .fail( dfd.reject )
      .then( next, next );
  }

  // queue our ajax request
  ajaxQueue.queue( doRequest );

  // add the abort method
  promise.abort = function( statusText ) {

    // proxy abort to the jqXHR if it is active
    if ( jqXHR ) {
      return jqXHR.abort( statusText );
    }

    // if there wasn't already a jqXHR we need to remove from queue
    var queue = ajaxQueue.queue(),
      index = $.inArray( doRequest, queue );

    if ( index > -1 ) {
      queue.splice( index, 1 );
    }

    // and then reject the deferred
    dfd.rejectWith( ajaxOpts.context || ajaxOpts, [ promise, statusText, "" ] );
    return promise;
  };

  return promise;
}

ShopifyAPI.addBundleItems = function(items, parent) {
  let total = items.length, i = 1;

  items.forEach(function(item) {
    $.ajaxQueue({
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: item,
        properties: {
          'bundle_product': 'yes',
          'parent': parent
        }
      },
      type: "POST",
      dataType: "json",
      success: function(data) {
      }
    }).done(function(data, response) {
      if (isAjaxify) {
        if (i == total) {
          ajaxCart.load();
        }

        $('.product-bundle--item.loop-'+i).css('opacity', '.2');
        i++;
      }
      else {
        window.location = '/cart'
      }
    })
  });
}

ShopifyAPI.removeBundleItems = function(items, is_cartpage) {
  let total = items.length, i = 1;

  $.each(items, function(index, item) {
    $.ajaxQueue({
      url: "/cart/change.js",
      data: {
        quantity: 0,
        id: item
      },
      type: "POST",
      dataType: "json",
      success: function(data, response) {
      }
    }).done(function(data, response) {
      if (i == total) {
        if (is_cartpage || !isAjaxify) {
          window.location.href = '/cart'
        }
        else {
          ajaxCart.load();
        }
      }

      i++;
    })
  });
}

ShopifyAPI.addToCartOk = function(){  
  ajaxCart.load();
}

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, getProduct;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled and use-ajax data is undefined or true
    if (!settings.disableAjaxCart && $addToCart.length && $addToCart.data('use-ajax') !== false) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

 updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $('.site-header__cart-indicator').removeClass('hide');
      $('.site-header__cart-indicator, .drawer__cart-indicator').html(cart.item_count);

      if (cart.item_count === 0) {
        $('.site-header__cart-indicator').addClass('hide');
      }
    }
  };

  formOverride = function () {
    $(document).on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      var $form = $(evt.target);
      var params = $form.serializeArray();
      var idParam = params.find(function(e) { return e.name == 'id' });
      if (!idParam || !idParam.value) {
        var optionsParam = params.find(function(e) { return e.name == 'options' });

        if (!optionsParam) {
          alert('Please select one of the variants.');
        }
        else {
          alert('Please select '+optionsParam.value+'.');
        }
      }
      else {
        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      }
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
       // $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  getProduct = function(handle, callback) {
    $.getJSON('/products/'+handle, function (res, textStatus) {
      if (res && res.product) {
        callback(res.product);
      }
      else {
        if ((typeof callback) === 'function') {
          callback(null);
        }
      }
    });
  };

  buildCart = function (cart) {

    $.get('/cart?view=subscription-info', function (subscriptionInfo, textStatus) {
      subscriptionInfo = JSON.parse(subscriptionInfo);
      buildCartContinue(cart, subscriptionInfo);
    });
  }

  var buildCartContinue = function (cart, subscriptionInfo) {
    
    $('.Sidebar.Open').removeClass('Open');
    $('.Overlay').hide();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.empty();
      $cartContainer
        .append('<p class="empty-cart">' + "NOTHING IN HERE" + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        no_sample_items = [],
        sample_item_lines = [],
        bundle_items = [];

    // Ordergroove items
    var og_items = [];
    /*if (localStorage.getItem('OG_STATE')) {
      try {
        og_items = JSON.parse(localStorage.getItem('OG_STATE')).optedin;
      }
      catch(e) {
        console.log(e);
      }
    }*/
    
    /*console.log('CART', cart);
    
    if (cart.total_price >= 3000) {
      $('#versed-static-shipping-message h4').html('You Now Have Free Shipping'); 
    } else {
      $('#versed-static-shipping-message h4').html('TEST'); 
    }*/

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      if (cartItem.properties && cartItem.properties.bundle_product == 'yes') {
        if (bundle_items.findIndex(function(item) { return item.handle == cartItem.properties.parent }) == -1) {
          bundle_items.push({
            handle: cartItem.properties.parent,
            itemQty: cartItem.quantity,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            vendor: cartItem.vendor,
            price: 0,
            linePrice: 0,
            originalPrice: 0,
            variants: [],
            discounts: cartItem.discounts,
            discountsApplied: cartItem.line_price === (cartItem.line_price - cartItem.total_discount) ? false : true
          });

          no_sample_items.push(cartItem.properties.parent);
        }

        let bundle_item = bundle_items.find(function(_item) { return _item.handle == cartItem.properties.parent });
        bundle_item.price += cartItem.price;
        bundle_item.linePrice += cartItem.line_price;
        bundle_item.originalPrice += (cartItem.line_price + cartItem.total_discount);
        bundle_item.variants.push(cartItem.variant_id);
      }
      else {
        /* Hack to get product image thumbnail
         *   - If image is not null
         *     - Remove file extension, add _300x, and re-add extension
         *     - Create server relative link
         *     - Create responsive variant (`_{width}x` as size)
         *   - A hard-coded url of no-image
        */
        var prodImgResponsive = null
        if (cartItem.image != null){
          var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', '');
          var prodImgResponsive = cartItem.image.replace(/(\.[^.]*)$/, "_{width}x$1").replace('http:', '');
        } else {
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        // Check Recharge
        var isSubscription = false,rechargeCycle="";
       
        if (cartItem.selling_plan_allocation != null) {
          isSubscription = true;
          var plan_name = cartItem.selling_plan_allocation.selling_plan.name.replace('Deliver Every', 'Delivered Every');
          rechargeCycle = plan_name + ", 10% off";
        }
        var og_item = og_items.find(function(e) { return Number(e.id) == cartItem.variant_id});

        if (cartItem.properties && cartItem.properties.og_subscription == "true" && og_item && cartItem.selling_plan_allocation != null) {
          isSubscription = true;
//           var frequency_patterns = og_item.frequency.split("_");
//           var period = Number(frequency_patterns[0]);
//           var unit = Number(frequency_patterns[1]);
//           var unit_str = "";
          
          
//           if (unit == 1) {
//             unit_str = "Day";
//           }
//           else if (unit == 2) {
//             unit_str = "Week";
//           }
//           else if (unit == 3) {
//             unit_str = "Month";
//           }
//           if (period > 1) {
//             unit_str += "s";
//           }

//           rechargeCycle = period+' '+unit_str;
          
          
          var plan_name = cartItem.selling_plan_allocation.selling_plan.name;
          rechargeCycle = plan_name;
        }

        // Check isGWP;
        var isGWP = false;
        /*if (free_mint_headband > 0 || free_overnight_peel > 0) {
          if (cartItem.variant_id == free_mint_headband && cartItem.properties.gwp) isGWP = true;
          if (cartItem.variant_id == free_overnight_peel && cartItem.properties.gwp) isGWP = true;
        }
        
        if(cartItem.properties.gwp){
        	isGWP = true;
        }*/
        if(cartItem.id == 39340636733475){
          data.donation = true;
        }
        
        var itemSubscriptionInfo = subscriptionInfo.find(itm => itm.key == cartItem.key);
        var sellingPlans = [];
        var lineIndex = index + 1;
        $.each(itemSubscriptionInfo.selling_plan_groups, function(index, item) {
          if (item.app_id == "294517") { // Recharge ID
            $.each(item.selling_plans, function(ind, itm) {
              if (cartItem.selling_plan_allocation != null) {
                itm.selected = itm.id == cartItem.selling_plan_allocation.selling_plan.id;
              } else {
                itm.selected = itm.id == false;
              }
              itm.name = itm.name.replace('Deliver Every', 'Every');
              itm.lineIndex = lineIndex;
              itm.qty = cartItem.quantity;
              sellingPlans.push(itm);
            });
          }
        });

        // Create item's data object and add to 'items' array
        item = {
          id: cartItem.variant_id,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          imgResponsive: prodImgResponsive,
          name: cartItem.product_title,
          type: cartItem.product_type,
          isSample: sample_variants.includes(cartItem.variant_id),
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
          vendor: cartItem.vendor,
          linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
          originalPrice: Shopify.formatMoney((cartItem.line_price + cartItem.total_discount), settings.moneyFormat),
          discounts: cartItem.discounts,
          discountsApplied: cartItem.line_price === (cartItem.line_price - cartItem.total_discount) ? false : true,
	        isGWP: isGWP,
          isSubscription: isSubscription,
          rechargeCycle: rechargeCycle,
          hasSubscription: sellingPlans.length > 0,
          sellingPlans: sellingPlans
        };

        items.push(item);
        if (!item.isSample) {
          no_sample_items.push(item.id)
        }
        else {
          sample_item_lines.push(item.id)
        }
      } 
    });

    if (no_sample_items.length == 0 && sample_item_lines.length > 0) {
      sample_item_lines.forEach(function(item) {
        ShopifyAPI.changeItemById(item, 0, adjustCartCallback);
      })
    }
    else {
      var shippingThreshold = 3500;
      var gwpThreshold = 5000;
      var enabledGWPMessage = true;
      var disclaimer = '';
      var prevOrders = $('body').data('orders');
      var bar = Shopify.currency.active == "USD" ? true : false;
      var message_type = 1;
      var shippingMessage = 'FREE SHIPPING ON ORDERS ' + Shopify.formatMoney(shippingThreshold, window.default_currency_format) + '+';
      if(!bar){
      	shippingThreshold = 10000;
        shippingMessage = 'FREE SHIPPING ON ORDERS OVER $100';
        message_type = 4;
        if (!prevOrders) {
		  shippingMessage += ' + FREE GIFT FOR NEW CUSTOMERS ON ORDERS OVER $50';
          message_type = 5;
        }
      }
      var bar_price=Shopify.formatMoney(shippingThreshold,window.default_currency_format);
      var amountToFreeShipping = shippingThreshold - cart.total_price;
      var amountToGWP = gwpThreshold - cart.total_price;
      var barPercent = 0;
      if (bar) {
        if (amountToFreeShipping <= 0) {
          shippingMessage = 'YOU NOW HAVE FREE SHIPPING';
          
          if (prevOrders) {
            barPercent = 100;
          } else {
            if (enabledGWPMessage) {
              if (amountToGWP <= 0) {
                barPercent = 100;
                shippingMessage += ' + A FREE GIFT*';
                disclaimer = '<br />*Free Gift for new customers only.'
                message_type = 3;
              } else {
                barPercent = Math.round(((gwpThreshold - amountToGWP) / gwpThreshold) * 100);
                shippingMessage += '<br />FREE GIFT FOR NEW CUSTOMERS, ADD ' + Shopify.formatMoney(amountToGWP, window.default_currency_format);
                message_type = 2;
              }
            } else {
              barPercent = 100;
            }
          }
          
        } else {
          shippingMessage = 'FREE SHIPPING WHEN YOU ADD ' + Shopify.formatMoney(amountToFreeShipping, window.default_currency_format);
          barPercent = Math.round(((shippingThreshold - amountToFreeShipping) / shippingThreshold) * 100);
        }
      }
      
      data = {
        note: cart.note,
        totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
        totalCartDiscount: cart.total_discount === 0 ? 0 : "YOU'RE SAVING [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
        totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
        bar:bar,
        bar_price:bar_price,
        bar_fill_percent: barPercent + '%',
        shipping_message: shippingMessage,
        disclaimer: disclaimer,
        message_type: message_type,
        upsell_products: []
      }

      let item = {};

      if (bundle_items.length > 0) {
        let count = 0;
        $.each(bundle_items, function(index, bundleItem) {
          getProduct(bundleItem.handle, function(product) {
            count++;
            if (product) {
              var prodImgResponsive = null
              if (product.image != null){
                var prodImg = product.image.src.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', '');
                var prodImgResponsive = product.image.src.replace(/(\.[^.]*)$/, "_{width}x$1").replace('http:', '');
              } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
              }
              
              if(product.variants[0].id == 39340636733475){
              	data.donation = true;
              }
              
              item = {
                id: product.variants[0].id,
                line: 0, // Shopify uses a 1+ index in the API
                url: '/products/'+product.handle,
                img: prodImg,
                imgResponsive: prodImgResponsive,
                name: product.title,
                type: product.product_type,
                isSample: false,
                properties: {},
                itemAdd: bundleItem.itemAdd,
                itemMinus: bundleItem.itemMinus,
                itemQty: bundleItem.itemQty,
                price: Shopify.formatMoney(bundleItem.price, settings.moneyFormat),
                vendor: bundleItem.vendor,
                linePrice: Shopify.formatMoney(bundleItem.linePrice, settings.moneyFormat),
                originalPrice: Shopify.formatMoney(bundleItem.originalPrice, settings.moneyFormat),
                discounts: bundleItem.discounts,
                discountsApplied: bundleItem.discountsApplied,
                variants: bundleItem.variants,
                isBundleProduct: true,
                isGWP: false
              }

              items.push(item);
            }

            if (count === bundle_items.length) {
              data['items'] = items;

              var ckp = data.items.find(x => x.id == 39340636733475);
              if(ckp){
                data.donation = true;
              }else{
                data.donation = false;
              }
            }
          });
        })
      }
      else {
        // Gather all cart data and add to DOM
        data['items'] = items;

        var ckp = data.items.find(x => x.id == 39340636733475);
        if(ckp){
          data.donation = true;
        }else{
          data.donation = false;
        }
        
      }

      
      // get upsell products
      var upsell_collection = 'add-a-best-seller';
      $.getJSON('/collections/add-a-best-seller/products.json', function (upsell_products, textStatus) {
        if (upsell_products.products.length) {
          var upsells = [];
          $.each(upsell_products.products, function () {
            var default_variant = this.variants[0];
            if (default_variant.available) {
              var cart_items = data.items.find(x => x.id == default_variant.id);
              if (!cart_items) {
                var price = default_variant.price * 100;
                var upsell_item = {
                  id: default_variant.id,
                  title: this.title,
                  variant_title: default_variant.title,
                  product_type: this.product_type,
                  price: Shopify.formatMoney(price, window.default_currency_format),
                  image: this.images[0].src.replace('.jpg', '_300x.jpg')
                };
                upsells.push(upsell_item);
              }
            }
          });
          data.upsell_products_raw = upsell_products;
          data.upsell_products = upsells.slice(0, 3);


        }
        // Start with a fresh cart div
        $cartContainer.empty();

        $cartContainer.append(template(data));

        cartCallback(cart);

        if (data.donation) {
          jQuery("#donation").prop('checked', true);
        } else {
          jQuery("#donation").prop('checked', false);
        }
        window.ccart = data;
        console.log(data);

      });
      

    }
    
    
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
	if (window.Shopify && Shopify.StorefrontExpressButtons) {
		Shopify.StorefrontExpressButtons.initialize();
	}

      var progress_style = $('#progress-style');
      var progress_bar_style = '.versed_progress_made { width: ' + $('.versed_progress_made').data('width') + '; }';
      if (!progress_style.length) {
        progress_style = $('<style/>').attr({ id: "progress-style", type: "text/css" }).appendTo("head");
      }
      progress_style.html(progress_bar_style);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
        if (qty === 7) qty = 6;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
        if (isUpdating) {
            return;
        }

        var $el = $(this),
            line = $el.data('line'),
            qty = 0;

        // Remove all items of this type from the cart
        if (line) {
            updateQuantity(line, qty);
        }

    });


    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      // setTimeout(function() {
        $el.select();
      // }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      // setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      // }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
    
    $body.on('click', '#donation', function() {
      if(jQuery(this).prop('checked')){
      	ShopifyAPI.addDonation();
      }else{
      	ShopifyAPI.removeDonation();
      }
    });
    
    
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    // setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    // }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('#Quantity');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          if (qty === 7) qty = 6;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };



  module = {
    init: init,
    load: loadCart,
    buildCart: buildCart
  };

  return module;

}(ajaxCart || {}));

function setSellingPlan(lineIndex, quantity, sellingPlanId) {
  ajaxCart.isUpdating = true;
  var $row = $('.ajaxcart__row[data-line="' + lineIndex + '"]').addClass('is-loading');
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      'line': lineIndex,
      'selling_plan': sellingPlanId,
      'quantity': quantity
    },
      dataType: 'json', 
     success: function (data) { 
      console.log(data);
      //$body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      ajaxCart.load();
     } 
  });
}

function updateSellingPlan(lineIndex, quantity, selector) {
  var sellingPlanId = $(selector).val();
  setSellingPlan(lineIndex, quantity, sellingPlanId);
}

function removeSellingPlan(lineIndex, quantity) {
  setSellingPlan(lineIndex, quantity, null);
}

function addSellingPlan(lineIndex, quantity, sellingPlanId) {
  setSellingPlan(lineIndex, quantity, sellingPlanId);
}